export function roundToFranc(val) {
  const n = parseFloat(val);
  if (Number.isNaN(n)) return 0;
  return Math.round(n * 20) / 20;
}

export function formatPrice(val) {
  if (val == null || (typeof val === 'number' && Number.isNaN(val))) return '-';
  const n = roundToFranc(val);
  return new Intl.NumberFormat('de-CH', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n) + ' CHF';
}
